export default "__VITE_ASSET__Bqg$hVT7__"